// src/helpers/environment.ts
function isSSR() {
  return typeof window === "undefined";
}
function isDebug() {
  return process.env.NODE_ENV === "development";
}
export {
  isDebug,
  isSSR
};
//# sourceMappingURL=environment.mjs.map